import React, { useState, useEffect } from 'react';
import { List, User } from '@phosphor-icons/react';
import { NotificationBell } from '../common';
import { isAdminUser } from '../../utils/permissions';
import './Header.css';

export function Header({ title, subtitle, onMenuClick, actions }) {
  const [user, setUser] = useState({ name: 'Admin', role: 'Operations' });

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser({
          name: userData.name || userData.email?.split('@')[0] || 'Admin',
          role: userData.role || 'Admin'
        });
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }, []);

  if (!isAdminUser()) {
    return (
      <header className="header header-minimal">
        <button className="menu-btn" onClick={onMenuClick} aria-label="Open menu">
          <List size={24} />
        </button>
      </header>
    );
  }

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-btn" onClick={onMenuClick} aria-label="Open menu">
          <List size={24} />
        </button>
        <div className="header-title-group">
          <h1 className="header-title">{title}</h1>
          {subtitle && <p className="header-subtitle">{subtitle}</p>}
        </div>
      </div>

      <div className="header-right">
        {actions && <div className="header-actions">{actions}</div>}

        <NotificationBell />

        <div className="user-profile">
          <div className="profile-avatar" aria-label={`User: ${user.name}`}>
            <User size={18} />
          </div>
          <div className="profile-info">
            <span className="profile-name">{user.name}</span>
            <span className="profile-role">{user.role}</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
